<template>
  <div class="ma-10">
    <v-row v-if="fisrtValidationAlert">
      <v-col cols="12">
        <v-alert :value="fisrtValidationAlert" type="error">
          {{ fisrtValidationError }}
        </v-alert>
      </v-col>
    </v-row>

    <v-row v-if="successAlert">
      <v-col cols="12">
        <v-alert :value="successAlert" type="success">
          {{ successInfo }}
        </v-alert>
      </v-col>
    </v-row>

    <div v-if="!fisrtValidationAlert && !successAlert" style="position: relative;">
      <div :class="canSave || canFinish ? '' : 'ro'"></div>
      <div style="float: right">
        <v-btn small @click="maximizeScreen">Maximizar</v-btn>
      </div>
      <Title title="Dados Principais"></Title>

      <v-row class="mt-0">
        <v-col cols="4" class="pt-0 pb-0">
          <v-text-field v-model="studyForm.documentNumber" label="CNPJ" readonly dense outlined></v-text-field>
        </v-col>
        <v-col cols="4" class="pt-0 pb-0">
          <v-text-field v-model="studyForm.legalName" label="Razão Social" readonly dense outlined></v-text-field>
        </v-col>
        <v-col cols="4" class="pt-0 pb-0">
          <v-text-field v-model="studyForm.status" label="Status" readonly dense outlined></v-text-field>
        </v-col>
      </v-row>
      <v-row class="mt-0">
        <v-col cols="4" class="pt-0 pb-0">
          <v-text-field v-model="studyForm.contactName" label="Nome do Contato" readonly dense outlined></v-text-field>
        </v-col>
        <v-col cols="4" class="pt-0 pb-0">
          <v-text-field v-model="studyForm.contactEmail" label="E-mail do Contato" readonly dense
                        outlined></v-text-field>
        </v-col>
        <v-col cols="4" class="pt-0 pb-0">
          <v-text-field v-model="studyForm.contactPhone" label="Telefone do Contato" readonly dense
                        outlined></v-text-field>
        </v-col>
      </v-row>
      <v-row class="mt-0">
        <v-col cols="3" class="pt-0 pb-0">
          <v-select :items="studyConfigurationsType" v-model="studyForm.studyConfiguration"
                    item-value="id" item-text="name" outlined dense
                    label="Configuração do Estudo"
                    @change="getStudyTypes"
                    return-object
                    :loading="studyConfigurationsType.length==0"></v-select>
        </v-col>
        <v-col cols="3" class="pt-0 pb-0">
          <v-select :items="studyTypes" v-model="studyForm.studyType"
                    item-value="id" item-text="description" outlined dense
                    label="Tipo de Estudo"
                    return-object
                    @change="studyTypeSelected"
                    :loading="studyTypes.length==0"></v-select>
        </v-col>
        <v-col cols="3" class="pt-0 pb-0">
          <v-text-field v-model="studyForm.createdAt" label="Data prevista de entrega do estudo" readonly dense
                        outlined></v-text-field>
        </v-col>
        <v-col cols="3" class="pt-0 pb-0">
          <v-text-field v-model="studyForm.validity" label="Validade do estudo" readonly dense outlined></v-text-field>
        </v-col>
      </v-row>

      <Title title="Benefícios" v-if="studyForm.studyConfiguration!=null"></Title>

      <InsuranceTypeDialog :get-quote-reasons="getQuoteReasons" :studyForm="studyForm"
                           v-if="studyForm.studyConfiguration!=null"></InsuranceTypeDialog>

      <v-tabs v-model="insuranceTab" v-if="studyForm.benefit!=null">
        <v-tab class="primary--text" href="#tabs-1">
          {{ studyForm.benefit.name }}
          <v-btn icon small @click="removeBenefit">
            <v-icon small dark title="Remover">fas fa-times</v-icon>
          </v-btn>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="insuranceTab">
        <v-tab-item value="tabs-1">
          <v-row class="pt-5">
            <v-col cols="4">
              <v-select :items="quoteReasons" v-model="studyForm.quoteReason"
                        item-value="id" item-text="name" outlined dense return-object
                        label="Motivo do Estudo"></v-select>
            </v-col>
          </v-row>
          <v-row class="mt-0 pt-0">
            <v-col
                cols="4"
                v-if="this.studyForm.ageGroupWithoutPlan == null"
                class="pt-0"
            >
              <v-btn small @click="addLivesWithoutPlan">
                Adicionar vidas sem plano
              </v-btn>
            </v-col>
            <v-col
                v-if="this.studyForm.ageGroupWithoutPlan != null"
                class="pt-0 pl-0"
            >
              <IncludeAgeGroupTable
                  title="Distribuição por faixa etária de vidas sem plano"
                  :general-age-group="studyForm.ageGroupWithoutPlan"
                  :show-distribution="false"
                  :show-aggregate-peoples-percentage="false"
              >
              </IncludeAgeGroupTable>
            </v-col>
          </v-row>

          <IncludeCurrentSituation ref="currentSituationComponent"
                                   :current-situation="studyForm.currentSituation"
                                   :benefit="studyForm.benefit"
                                   :carrier-current-plans="studyForm.proposalSituation.scenarios[0].carrierCurrentPlans"
                                   :carrier-proposed-plan="studyForm.proposalSituation.scenarios[0].carrierProposedPlans"
                                   :reset-current-situation="resetCurrentSituation"
                                   :add-not-exist-current-plan="addNotExistCurrentPlan"
          ></IncludeCurrentSituation>

          <IncludeProposalSituation :benefit="studyForm.benefit" :account="studyForm.currentSituation.carrier"
                                    :proposal-situation="studyForm.proposalSituation"
                                    :find-prices="findPrices"
                                    :study-configuration="studyForm.studyConfiguration"
                                    :placement-permission="showPrices"></IncludeProposalSituation>

        </v-tab-item>
      </v-tabs-items>
      <br>
      <v-divider></v-divider>
      <br>
      <v-alert :value="alert" type="error" dismissible>
        {{ alertMessage }}
      </v-alert>
      <v-row justify="end" v-if="isLogingPermissions">
        <v-progress-circular indeterminate/>
      </v-row>
    </div>

    <div class="pt-8" v-if="!fisrtValidationAlert && !successAlert">
      <v-row justify="end" v-if="!isLogingPermissions">
        <v-btn small @click="saveType='SAVE'; studyForm.status=='Finalizado'? newQuoteWarningDialog=true : save()"
               v-if="canSave">
          <v-icon small left>fas fa-save</v-icon>
          Salvar
        </v-btn>
        &nbsp;
        <v-btn small @click="saveType='ANALYZE'; studyForm.status=='Finalizado'? newQuoteWarningDialog=true : sendPlacement()"
               v-if="canSendPlacement">
          <v-icon small left>fas fa-check</v-icon>
          Enviar para Analise
        </v-btn>
        &nbsp;
        <v-btn small @click="saveType='FINISH'; studyForm.status=='Finalizado'? newQuoteWarningDialog=true : finish()"
               v-if="canFinish">
          <v-icon small left>fas fa-check</v-icon>
          Finalizar Estudo
        </v-btn>
        <TemplateSelectDlg :quoteId="studyForm.quoteId" :report-generated="studyForm.reportGeneratedAt!=null"
                           v-if="canGeneratePresentation"/>
      </v-row>

      <v-dialog
          v-model="newQuoteWarningDialog"
          width="auto"
      >
        <v-card>
          <v-card-title class="text-h5">
            <strong>Aviso!</strong>
          </v-card-title>
          <v-card-text>
            <strong style="font-size: 18px">Ao prosseguir, será criado um novo estudo, deseja continuar?</strong><br>
            (Após o processamento, você será redirecionado para o novo estudo!)
          </v-card-text>
          <v-card-actions>
            <v-col cols="3"></v-col>
            <v-col cols="3">
              <v-btn color="error" block @click="newQuoteWarningDialog = false">Cancelar</v-btn>
            </v-col>
            <v-col cols="3">
              <v-btn color="primary" block @click="saveTypeAction">Prosseguir</v-btn>
            </v-col>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </div>
  </div>
</template>

<script>
import TemplateSelectDlg from "@/view/study/dialog/dlg_template_select";
import InsuranceTypeDialog from "@/view/study/dialog/dlg_insurance_type";
import IncludeAgeGroupTable from "@/view/study/includes/include_age_group_table";
import IncludeCurrentSituation from "@/view/study/includes/include_current_situation";
import IncludeProposalSituation from "@/view/study/includes/include_proposal_situation";
import Title from "@/components/structure/title";
import StudyConfigurationService from "@/services/odoo/StudyConfigurationService";
import StudyTypeService from "@/services/odoo/StudyTypeService";
import StudyService from "@/services/insurancepricing/StudyService";
import QuoteReasonService from "@/services/odoo/QuoteReasonService";
import AuthService from "@/services/AuthService";
import XippAuthService from "@/services/auth/XippAuthService";
import QuoteService from "@/services/odoo/QuoteService";
import {mapMutations} from "vuex";

export default {
  components: {
    Title,
    TemplateSelectDlg,
    IncludeCurrentSituation,
    IncludeProposalSituation,
    IncludeAgeGroupTable,
    InsuranceTypeDialog
  },
  data() {
    return {
      alert: false,
      alertMessage: '',
      fisrtValidationError: null,
      fisrtValidationAlert: false,
      successInfo: null,
      successAlert: false,
      insuranceTab: null,
      studyConfigurationsType: [],
      studyTypes: [],
      quoteReasons: [],
      canSave: false,
      canSendPlacement: false,
      canFinish: false,
      canGeneratePresentation: false,
      showPrices: false,
      isLogingPermissions: false,
      newQuoteWarningDialog: false,
      studyForm: {
        leadId: null,
        salesChannelId: null,
        quoteId: null,
        reportGeneratedAt: null,
        documentNumber: null,
        legalName: null,
        partnerName: null,
        contactDocumentNumber: null,
        contactName: null,
        contactEmail: null,
        contactPhone: null,
        status: 'Rascunho',
        studyConfiguration: null,
        studyType: null,
        createdAt: null,
        validity: null,
        benefit: null,
        quoteReason: null,
        ageGroupWithoutPlan: null,
        currentSituation: {
          notExist: false,
          carrier: null,
          benefitPolice: {
            paymentScheme: null,
            administrationFee: null,
            readjustmentForecast: null,
            lossRatio: null,
            technicalLimit: null,
            policyBirth: null,
            contractModel: null,
            contractDeadline: null,
            requestContractTerminationDeadline: null,
            terminationFineOutOfDeadline: null,
          },
          ageGroupWithPlan: [
            {
              ageGroup: 'Até 18 anos',
              femaleHolders: 0,
              maleHolders: 0,
              femaleLegalDependent: 0,
              maleLegalDependent: 0,
              femaleHouseHold: 0,
              maleHouseHold: 0,
              femaleFiredOrRetiree: 0,
              maleFiredOrRetiree: 0,
              femaleInactive: 0,
              maleInactive: 0,
              overall: 0,
              distribution: 0
            },
            {
              ageGroup: '19 até 23 anos',
              femaleHolders: 0,
              maleHolders: 0,
              femaleLegalDependent: 0,
              maleLegalDependent: 0,
              femaleHouseHold: 0,
              maleHouseHold: 0,
              femaleFiredOrRetiree: 0,
              maleFiredOrRetiree: 0,
              femaleInactive: 0,
              maleInactive: 0,
              overall: 0,
              distribution: 0
            },
            {
              ageGroup: '24 até 28 anos',
              femaleHolders: 0,
              maleHolders: 0,
              femaleLegalDependent: 0,
              maleLegalDependent: 0,
              femaleHouseHold: 0,
              maleHouseHold: 0,
              femaleFiredOrRetiree: 0,
              maleFiredOrRetiree: 0,
              femaleInactive: 0,
              maleInactive: 0,
              overall: 0,
              distribution: 0
            },
            {
              ageGroup: '29 até 33 anos',
              femaleHolders: 0,
              maleHolders: 0,
              femaleLegalDependent: 0,
              maleLegalDependent: 0,
              femaleHouseHold: 0,
              maleHouseHold: 0,
              femaleFiredOrRetiree: 0,
              maleFiredOrRetiree: 0,
              femaleInactive: 0,
              maleInactive: 0,
              overall: 0,
              distribution: 0
            },
            {
              ageGroup: '34 até 38 anos',
              femaleHolders: 0,
              maleHolders: 0,
              femaleLegalDependent: 0,
              maleLegalDependent: 0,
              femaleHouseHold: 0,
              maleHouseHold: 0,
              femaleFiredOrRetiree: 0,
              maleFiredOrRetiree: 0,
              femaleInactive: 0,
              maleInactive: 0,
              overall: 0,
              distribution: 0
            },
            {
              ageGroup: '39 até 43 anos',
              femaleHolders: 0,
              maleHolders: 0,
              femaleLegalDependent: 0,
              maleLegalDependent: 0,
              femaleHouseHold: 0,
              maleHouseHold: 0,
              femaleFiredOrRetiree: 0,
              maleFiredOrRetiree: 0,
              femaleInactive: 0,
              maleInactive: 0,
              overall: 0,
              distribution: 0
            },
            {
              ageGroup: '44 até 48 anos',
              femaleHolders: 0,
              maleHolders: 0,
              femaleLegalDependent: 0,
              maleLegalDependent: 0,
              femaleHouseHold: 0,
              maleHouseHold: 0,
              femaleFiredOrRetiree: 0,
              maleFiredOrRetiree: 0,
              femaleInactive: 0,
              maleInactive: 0,
              overall: 0,
              distribution: 0
            },
            {
              ageGroup: '49 até 53 anos',
              femaleHolders: 0,
              maleHolders: 0,
              femaleLegalDependent: 0,
              maleLegalDependent: 0,
              femaleHouseHold: 0,
              maleHouseHold: 0,
              femaleFiredOrRetiree: 0,
              maleFiredOrRetiree: 0,
              femaleInactive: 0,
              maleInactive: 0,
              overall: 0,
              distribution: 0
            },
            {
              ageGroup: '54 até 58 anos',
              femaleHolders: 0,
              maleHolders: 0,
              femaleLegalDependent: 0,
              maleLegalDependent: 0,
              femaleHouseHold: 0,
              maleHouseHold: 0,
              femaleFiredOrRetiree: 0,
              maleFiredOrRetiree: 0,
              femaleInactive: 0,
              maleInactive: 0,
              overall: 0,
              distribution: 0
            },
            {
              ageGroup: 'A partir de 59 anos',
              femaleHolders: 0,
              maleHolders: 0,
              femaleLegalDependent: 0,
              maleLegalDependent: 0,
              femaleHouseHold: 0,
              maleHouseHold: 0,
              femaleFiredOrRetiree: 0,
              maleFiredOrRetiree: 0,
              femaleInactive: 0,
              maleInactive: 0,
              overall: 0,
              distribution: 0
            },
          ],
          plans: []
        },
        proposalSituation: {
          coparticipation: {
            value: null,
            type: null,
            consultationDesign: null,
            consultationPSDesign: null,
            examsDesign: null,
            otherDesigns: null
          },
          secondCoparticipation: {
            value: null,
            type: null,
            consultationDesign: null,
            consultationPSDesign: null,
            examsDesign: null,
            otherDesigns: null
          },
          networkOpening: null,
          withoutCurrentSituation: false,
          specific: false,
          showInactiveLives: false,
          showHouseHoldLives: false,
          scenarios: [
            {
              carrierCurrentPlans: {
                regions: [],
                mainRegion: null,
                carrier: {name: null},
                notes: null,
                plans: [],
              },
              carrierProposedPlans: []
            }
          ]
        }
      }
    };
  },
  methods: {
    ...mapMutations(["toogleDialogLoading"]),
    model() {
      return this.studyForm;
    },
    removeBenefit() {
      this.resetBenefit();
      this.resetCurrentSituation(false);
    },
    addInitialCarrierProposedPlans(isReferenced) {
      this.studyForm.proposalSituation.scenarios[0].carrierProposedPlans.push({
        width: 345,
        adm: false,
        carrier: null,
        notes: null,
        isReferencedCarrier: isReferenced,
        plans: [],
        plansType: []
      });
    },
    async getStudyConfigurations() {
      if (this.studyConfigurationsType.length == 0) {
        const {data} = await this._studyConfigurationService.findAllBySalesChannelId(this.studyForm.salesChannelId);
        this.studyConfigurationsType = data;
      }
    },
    async getStudyTypes() {
      const {data} = await this._studyTypeService.findAllByStudyConfigurationId(this.studyForm.studyConfiguration.id);
      this.studyTypes = data;

      if (this.studyForm.studyConfiguration != null && this.studyForm.studyConfiguration.proposalValidity != null) {
        let dt = new Date();
        dt.setDate(dt.getDate() + this.studyForm.studyConfiguration.proposalValidity);
        this.studyForm.validity = dt.toLocaleDateString();
      }
    },
    studyTypeSelected() {
      if (this.studyForm.studyType != null && this.studyForm.studyType.studyTypeConfigurations != null
          && this.studyForm.studyType.studyTypeConfigurations.length > 0) {
        let stc = this.studyForm.studyType.studyTypeConfigurations[0];

        if (stc.operation != null) {
          let dt = new Date();
          dt.setDate(dt.getDate() + parseInt(stc.operation));
          this.studyForm.createdAt = dt.toLocaleDateString();
        }
      }
    },
    async getQuoteReasons() {
      const {data} = await this._quoteReasonService.findAllByBenefit(this.studyForm.benefit.id);
      this.quoteReasons = data;
    },
    saveTypeAction() {
      this.newQuoteWarningDialog = false;
      if (this.saveType == 'SAVE') {
        this.save();
      } else if (this.saveType == 'ANALYZE') {
        this.sendPlacement();
      } else if (this.saveType == 'FINISH') {
        this.finish();
      }
    },
    async getPermissions() {
      this.isLogingPermissions = true;
      try {
        let response = await this._authService.findCurrent();
        let authorities = response.data.authorities;
        localStorage.setItem("uid", response.data.id);
        let areaApoio = authorities.filter(
          (a) => (a.authority == 'estudo_editar_custos')
        ).length > 0;

        var commercialSates = ['draft', 'pending_information', 'fulfilled', 'declined', 'presented', 'lost'];
        var placementStates = ['open', 'proposed_analysis', 'carrier_sent', 'in_validation'];
        if (areaApoio) {
          this.showPrices = true;
          this.canSave = true;
          this.canSendPlacement = false;
          this.canFinish = true;
          this.canGeneratePresentation =  this.studyForm.status == 'Finalizado';
        } else {
          console.log('State:'+this.studyForm.state);
          console.log('commercialSates: '+commercialSates.includes(this.studyForm.state));
          this.showPrices = false;
          this.canSave = !this.studyForm.quoteId || commercialSates.includes(this.studyForm.state);
          this.canSendPlacement= !this.studyForm.quoteId && this.studyForm.status=='Rascunho';
          this.canFinish = false;
          this.canGeneratePresentation = false;
        }
      } catch (error) {
        this.alert = true;
        this.alertMessage = error;
      } finally {
        this.isLogingPermissions = false;
      }
    },

    async save() {
      if (this.formIsValid()) {
        this.toogleDialogLoading(true);
        const response = await this._studyService.save(this.studyForm);
        this.toogleDialogLoading(false);
        if (response.status == 200) {
          this.successAlert = true;
          if(this.studyForm.status=='Em analise' && !this.studyForm.quoteId){
            this.successInfo = 'Estudo enviado para analise com sucesso!';
          } else {
            this.successInfo = 'Estudo salvo com sucesso!';
            setTimeout(window.location.reload(), 50000);
          }
        } else {
          this.alert = true;
          this.alertMessage = 'Ocorreu um erro ao salvar o estudo.';
        }
      }
    },
    async sendPlacement() {
      if (this.formIsValid()) {
        this.studyForm.status='Em analise';
        await this.save();
      }
    },
    async finish() {
      if (this.formIsValid()) {
        this.toogleDialogLoading(true);
        var response = await this._studyService.finish(this.studyForm);
        this.toogleDialogLoading(false);
        if (response.status == 200) {
            this.successAlert = true;
            this.successInfo = 'Estudo finalizado com sucesso!';
        } else {
          this.alert = true;
          this.alertMessage = 'Ocorreu um erro ao finalizar o estudo.';
        }
      }
    },
    formIsValid() {

      if (this.studyForm.proposalSituation.scenarios.length > 0 &&
          !this.studyForm.proposalSituation.scenarios[0].carrierCurrentPlans.mainRegion ||
          !this.studyForm.proposalSituation.scenarios[0].carrierCurrentPlans.mainRegion.id) {

        this.alert = true;
        this.alertMessage = 'Preencha a região Principal .';
        return false;
      }

      if (!this.studyForm.proposalSituation.coparticipation.value) {
        this.alert = true;
        this.alertMessage = 'Preencha o valor da coparticipação.';
        return false;
      }

      if (this.studyForm.proposalSituation.coparticipation.value != '0' &&
          !this.studyForm.proposalSituation.coparticipation.type) {

        this.alert = true;
        this.alertMessage = 'Preencha o tipo da coparticipação.';
        return false;
      }

      if (!this.studyForm.proposalSituation.secondCoparticipation.value) {
        this.alert = true;
        this.alertMessage = 'Preencha o valor da segunda coparticipação.';
        return false;
      }

      if (this.studyForm.proposalSituation.secondCoparticipation.value != '0' &&
          !this.studyForm.proposalSituation.secondCoparticipation.type) {

        this.alert = true;
        this.alertMessage = 'Preencha o tipo da segunda coparticipação.';
        return false;
      }

      if (!this.validLives()) {
        this.alert = true;
        this.alertMessage = 'As vidas preenchidas da distribuição não condiz com as vidas dos planos atuais.';
        return false;
      }

      if (this.studyForm.proposalSituation.financialConsolidatedNote) {
        this.studyForm.proposalSituation.financialConsolidatedNote = this.studyForm.proposalSituation.financialConsolidatedNote
            .replaceAll('#', '&35;').replaceAll('*', '&42;');
      }
      if (this.studyForm.proposalSituation.ageGroupCostNote) {
        this.studyForm.proposalSituation.ageGroupCostNote = this.studyForm.proposalSituation.ageGroupCostNote
            .replaceAll('#', '&35;').replaceAll('*', '&42;');
      }
      if (this.studyForm.proposalSituation.financialComparisonNote) {
        this.studyForm.proposalSituation.financialComparisonNote = this.studyForm.proposalSituation.financialComparisonNote
            .replaceAll('#', '&35;').replaceAll('*', '&42;');
      }

      return true;
    },
    validLives() {
      if (!this.$refs.currentSituationComponent) {
        return false;
      }

      let total = 0;
      this.studyForm.currentSituation.ageGroupWithPlan.forEach(a => {
        total += a.overall ? a.overall : 0;
      });

      return total == this.$refs.currentSituationComponent.totalHealthCarePlanAgeGroup.overall;
    },
    getvalue(fields, name) {
      if (fields.some((s) => s.key == name)) {
        return fields.find((f) => f.key == name).value.replace("undefined", "");
      } else {
        return "";
      }
    },
    addNotExistCurrentPlan() {
      this.resetCurrentSituation(true);
      this.studyForm.proposalSituation.scenarios[0].carrierCurrentPlans.plans.push({
        product: {},
        consultationRefund: null,
        psychotherapyRefund: null,
        physiotherapyRefund: null,
        skullTomographyRefund: null,
        caesareanBirthRefund: null,
        revascularizationMyocardiumRefund: null,
        lives: null,
        openAgeGroupCost: false,
        openInactiveAgeGroupCost: false,
        openHouseHoldAgeGroupCost: false,
      });
      this.addCarrierProposedPlan(0);
      this.addCarrierProposedPlan(1);
      this.addCarrierProposedPlan(2);
      this.addCarrierProposedPlan(3);
    },
    addCarrierProposedPlan(index) {
      this.studyForm.proposalSituation.scenarios[0].carrierProposedPlans[index].plans.push({
        plansType: [],
        linedPlans: [{
          product: {},
          consultationRefund: null,
          psychotherapyRefund: null,
          physiotherapyRefund: null,
          skullTomographyRefund: null,
          caesareanBirthRefund: null,
          revascularizationMyocardiumRefund: null,
          lives: null,
          copay: {averageCost: null},
          secondCopay: {averageCost: null},
          inactiveLives: null,
          inactiveCopay: {averageCost: null},
          inactiveSecondCopay: {averageCost: null},
          houseHoldLives: null,
          houseHoldCopay: {averageCost: null},
          houseHoldSecondCopay: {averageCost: null},
          upgradePlans: [],
          downgradePlans: [],
          ageGroupCost: [],
          inactiveAgeGroupCost: [],
          houseHoldAgeGroupCost: []
        }]
      });
      for (let i = 0; i < 10; i++) {
        this.studyForm.proposalSituation.scenarios[0].carrierProposedPlans[index].plans[
        this.studyForm.proposalSituation.scenarios[0].carrierProposedPlans[index].plans.length - 1].linedPlans[0].ageGroupCost.push({
          id: i,
          lives: null,
          copayValue: null,
          secondCopayValue: null
        });
        this.studyForm.proposalSituation.scenarios[0].carrierProposedPlans[index].plans[
        this.studyForm.proposalSituation.scenarios[0].carrierProposedPlans[index].plans.length - 1].linedPlans[0].inactiveAgeGroupCost.push({
          id: i,
          lives: null,
          copayValue: null,
          secondCopayValue: null
        });
        this.studyForm.proposalSituation.scenarios[0].carrierProposedPlans[index].plans[
        this.studyForm.proposalSituation.scenarios[0].carrierProposedPlans[index].plans.length - 1].linedPlans[0].houseHoldAgeGroupCost.push({
          id: i,
          lives: null,
          copayValue: null,
          secondCopayValue: null
        });
      }
    },
    addLivesWithoutPlan() {
      this.studyForm.ageGroupWithoutPlan = [
        {
          ageGroup: 'Até 18 anos',
          femaleHolders: 0,
          maleHolders: 0,
          femaleLegalDependent: 0,
          maleLegalDependent: 0,
          femaleHouseHold: 0,
          maleHouseHold: 0,
          femaleFiredOrRetiree: 0,
          maleFiredOrRetiree: 0,
          femaleInactive: 0,
          maleInactive: 0,
          overall: 0
        },
        {
          ageGroup: '19 até 23 anos',
          femaleHolders: 0,
          maleHolders: 0,
          femaleLegalDependent: 0,
          maleLegalDependent: 0,
          femaleHouseHold: 0,
          maleHouseHold: 0,
          femaleFiredOrRetiree: 0,
          maleFiredOrRetiree: 0,
          femaleInactive: 0,
          maleInactive: 0,
          overall: 0
        },
        {
          ageGroup: '24 até 28 anos',
          femaleHolders: 0,
          maleHolders: 0,
          femaleLegalDependent: 0,
          maleLegalDependent: 0,
          femaleHouseHold: 0,
          maleHouseHold: 0,
          femaleFiredOrRetiree: 0,
          maleFiredOrRetiree: 0,
          femaleInactive: 0,
          maleInactive: 0,
          overall: 0
        },
        {
          ageGroup: '29 até 33 anos',
          femaleHolders: 0,
          maleHolders: 0,
          femaleLegalDependent: 0,
          maleLegalDependent: 0,
          femaleHouseHold: 0,
          maleHouseHold: 0,
          femaleFiredOrRetiree: 0,
          maleFiredOrRetiree: 0,
          femaleInactive: 0,
          maleInactive: 0,
          overall: 0
        },
        {
          ageGroup: '34 até 38 anos',
          femaleHolders: 0,
          maleHolders: 0,
          femaleLegalDependent: 0,
          maleLegalDependent: 0,
          femaleHouseHold: 0,
          maleHouseHold: 0,
          femaleFiredOrRetiree: 0,
          maleFiredOrRetiree: 0,
          femaleInactive: 0,
          maleInactive: 0,
          overall: 0
        },
        {
          ageGroup: '39 até 43 anos',
          femaleHolders: 0,
          maleHolders: 0,
          femaleLegalDependent: 0,
          maleLegalDependent: 0,
          femaleHouseHold: 0,
          maleHouseHold: 0,
          femaleFiredOrRetiree: 0,
          maleFiredOrRetiree: 0,
          femaleInactive: 0,
          maleInactive: 0,
          overall: 0
        },
        {
          ageGroup: '44 até 48 anos',
          femaleHolders: 0,
          maleHolders: 0,
          femaleLegalDependent: 0,
          maleLegalDependent: 0,
          femaleHouseHold: 0,
          maleHouseHold: 0,
          femaleFiredOrRetiree: 0,
          maleFiredOrRetiree: 0,
          femaleInactive: 0,
          maleInactive: 0,
          overall: 0
        },
        {
          ageGroup: '49 até 53 anos',
          femaleHolders: 0,
          maleHolders: 0,
          femaleLegalDependent: 0,
          maleLegalDependent: 0,
          femaleHouseHold: 0,
          maleHouseHold: 0,
          femaleFiredOrRetiree: 0,
          maleFiredOrRetiree: 0,
          femaleInactive: 0,
          maleInactive: 0,
          overall: 0
        },
        {
          ageGroup: '54 até 58 anos',
          femaleHolders: 0,
          maleHolders: 0,
          femaleLegalDependent: 0,
          maleLegalDependent: 0,
          femaleHouseHold: 0,
          maleHouseHold: 0,
          femaleFiredOrRetiree: 0,
          maleFiredOrRetiree: 0,
          femaleInactive: 0,
          maleInactive: 0,
          overall: 0
        },
        {
          ageGroup: 'A partir de 59 anos',
          femaleHolders: 0,
          maleHolders: 0,
          femaleLegalDependent: 0,
          maleLegalDependent: 0,
          femaleHouseHold: 0,
          maleHouseHold: 0,
          femaleFiredOrRetiree: 0,
          maleFiredOrRetiree: 0,
          femaleInactive: 0,
          maleInactive: 0,
          overall: 0
        },
      ];
    },
    resetBenefit() {
      this.studyForm.benefit = null;
      this.studyForm.quoteReason = null;
      this.insuranceTab = null;
      this.studyForm.ageGroupWithoutPlan = null;
    },
    resetCurrentSituation(exist) {
      this.$refs.currentSituationComponent.totalHealthCarePlanAgeGroup = {
        untilEighteenPeople: 0,
        nineteenToTwentyThreePeoples: 0,
        twentyFourToTwentyEightPeoples: 0,
        twentyNineToThirtyThreePeoples: 0,
        thirtyFourToThirtyEightPeoples: 0,
        thirtyNineToFortyThreePeoples: 0,
        fortyFourToFortyEightPeoples: 0,
        fortyNineToFiftyThreePeoples: 0,
        fiftyFourToFiftyEightPeoples: 0,
        fromFiftyNinePeoples: 0,
        overall: 0
      };
      this.studyForm.currentSituation = {
        notExist: exist,
        carrier: null,
        benefitPolice: {
          paymentScheme: null,
          administrationFee: null,
          readjustmentForecast: null,
          lossRatio: null,
          technicalLimit: null,
          policyBirth: null,
          contractModel: null,
          contractDeadline: null,
          requestContractTerminationDeadline: null,
          terminationFineOutOfDeadline: null,
        },
        ageGroupWithPlan: [
          {
            ageGroup: 'Até 18 anos',
            femaleHolders: 0,
            maleHolders: 0,
            femaleLegalDependent: 0,
            maleLegalDependent: 0,
            femaleHouseHold: 0,
            maleHouseHold: 0,
            femaleFiredOrRetiree: 0,
            maleFiredOrRetiree: 0,
            femaleInactive: 0,
            maleInactive: 0,
            overall: 0,
            distribution: 0
          },
          {
            ageGroup: '19 até 23 anos',
            femaleHolders: 0,
            maleHolders: 0,
            femaleLegalDependent: 0,
            maleLegalDependent: 0,
            femaleHouseHold: 0,
            maleHouseHold: 0,
            femaleFiredOrRetiree: 0,
            maleFiredOrRetiree: 0,
            femaleInactive: 0,
            maleInactive: 0,
            overall: 0,
            distribution: 0
          },
          {
            ageGroup: '24 até 28 anos',
            femaleHolders: 0,
            maleHolders: 0,
            femaleLegalDependent: 0,
            maleLegalDependent: 0,
            femaleHouseHold: 0,
            maleHouseHold: 0,
            femaleFiredOrRetiree: 0,
            maleFiredOrRetiree: 0,
            femaleInactive: 0,
            maleInactive: 0,
            overall: 0,
            distribution: 0
          },
          {
            ageGroup: '29 até 33 anos',
            femaleHolders: 0,
            maleHolders: 0,
            femaleLegalDependent: 0,
            maleLegalDependent: 0,
            femaleHouseHold: 0,
            maleHouseHold: 0,
            femaleFiredOrRetiree: 0,
            maleFiredOrRetiree: 0,
            femaleInactive: 0,
            maleInactive: 0,
            overall: 0,
            distribution: 0
          },
          {
            ageGroup: '34 até 38 anos',
            femaleHolders: 0,
            maleHolders: 0,
            femaleLegalDependent: 0,
            maleLegalDependent: 0,
            femaleHouseHold: 0,
            maleHouseHold: 0,
            femaleFiredOrRetiree: 0,
            maleFiredOrRetiree: 0,
            femaleInactive: 0,
            maleInactive: 0,
            overall: 0,
            distribution: 0
          },
          {
            ageGroup: '39 até 43 anos',
            femaleHolders: 0,
            maleHolders: 0,
            femaleLegalDependent: 0,
            maleLegalDependent: 0,
            femaleHouseHold: 0,
            maleHouseHold: 0,
            femaleFiredOrRetiree: 0,
            maleFiredOrRetiree: 0,
            femaleInactive: 0,
            maleInactive: 0,
            overall: 0,
            distribution: 0
          },
          {
            ageGroup: '44 até 48 anos',
            femaleHolders: 0,
            maleHolders: 0,
            femaleLegalDependent: 0,
            maleLegalDependent: 0,
            femaleHouseHold: 0,
            maleHouseHold: 0,
            femaleFiredOrRetiree: 0,
            maleFiredOrRetiree: 0,
            femaleInactive: 0,
            maleInactive: 0,
            overall: 0,
            distribution: 0
          },
          {
            ageGroup: '49 até 53 anos',
            femaleHolders: 0,
            maleHolders: 0,
            femaleLegalDependent: 0,
            maleLegalDependent: 0,
            femaleHouseHold: 0,
            maleHouseHold: 0,
            femaleFiredOrRetiree: 0,
            maleFiredOrRetiree: 0,
            femaleInactive: 0,
            maleInactive: 0,
            overall: 0,
            distribution: 0
          },
          {
            ageGroup: '54 até 58 anos',
            femaleHolders: 0,
            maleHolders: 0,
            femaleLegalDependent: 0,
            maleLegalDependent: 0,
            femaleHouseHold: 0,
            maleHouseHold: 0,
            femaleFiredOrRetiree: 0,
            maleFiredOrRetiree: 0,
            femaleInactive: 0,
            maleInactive: 0,
            overall: 0,
            distribution: 0
          },
          {
            ageGroup: 'A partir de 59 anos',
            femaleHolders: 0,
            maleHolders: 0,
            femaleLegalDependent: 0,
            maleLegalDependent: 0,
            femaleHouseHold: 0,
            maleHouseHold: 0,
            femaleFiredOrRetiree: 0,
            maleFiredOrRetiree: 0,
            femaleInactive: 0,
            maleInactive: 0,
            overall: 0,
            distribution: 0
          },
        ],
        plans: []
      };

      this.resetProposalSituation();
    },
    maximizeScreen() {
      window.open(this.$route.fullPath, '_blank').focus();
    },
    resetProposalSituation() {
      this.studyForm.proposalSituation = {
        coparticipation: {
          value: null,
          type: null,
          consultationDesign: null,
          consultationPSDesign: null,
          examsDesign: null,
          otherDesigns: null
        },
        secondCoparticipation: {
          value: null,
          type: null,
          consultationDesign: null,
          consultationPSDesign: null,
          examsDesign: null,
          otherDesigns: null
        },
        networkOpening: null,
        withoutCurrentSituation: false,
        specific: false,
        showInactiveLives: false,
        showHouseHoldLives: false,
        scenarios: [
          {
            carrierCurrentPlans: {
              regions: [],
              mainRegion: null,
              carrier: {name: null},
              notes: null,
              plans: [],
            },
            carrierProposedPlans: []
          }
        ]
      }
      this.addInitialCarrierProposedPlans(true);
      this.addInitialCarrierProposedPlans(false);
      this.addInitialCarrierProposedPlans(false);
      this.addInitialCarrierProposedPlans(false);
    },
    async findPrices() {
      const {data} = await this._studyService.findPrices(this.studyForm);
      this.studyForm = data;
    },
    async loadJWTToken() {
      if (this.$route.query && this.$route.query.token) {
        const sessionKey = "access_token";

        localStorage.setItem(sessionKey, this.$route.query.token);
        this.toogleDialogLoading(true);

        await this._xippAuthService.GetTokenFull()
            .then((response) => {
              if (response && response.data) {
                localStorage.setItem(sessionKey, response.data.token);
              }
            })
            .finally(() => {
              this.toogleDialogLoading(false);
            });
      }
    }
  },
  beforeCreate() {
    this._xippAuthService = new XippAuthService();
  },
  async created() {
    this._studyService = new StudyService();
    this._authService = new AuthService();
    this._studyTypeService = new StudyTypeService();
    this._quoteReasonService = new QuoteReasonService();
    this._quoteService = new QuoteService();
    this._studyConfigurationService = new StudyConfigurationService();
  },
  async beforeMount() {
    this.addInitialCarrierProposedPlans(true);
    this.addInitialCarrierProposedPlans(false);
    this.addInitialCarrierProposedPlans(false);
    this.addInitialCarrierProposedPlans(false);
      
    var token = this.$route.query.token;
    if (typeof token != 'undefined' && token != '') {
      localStorage.removeItem("access_token");
      localStorage.setItem("access_token", token);
      await this.loadJWTToken();

      if (typeof this.$route.query.type == 'undefined') {
        let content = await this._studyService.findByQuoteId(this.$route.query.id);
        if (content.data != '') {
          this.studyForm = content.data;
          this.studyForm.quoteId = this.$route.query.id;
          if (this.studyForm.proposalSituation.financialConsolidatedNote) {
            this.studyForm.proposalSituation.financialConsolidatedNote = this.studyForm.proposalSituation.financialConsolidatedNote
                .replaceAll('&amp;35;', '#').replaceAll('&amp;42;', '*')
                .replaceAll('&35;', '#').replaceAll('&42;', '*');
          }
          if (this.studyForm.proposalSituation.ageGroupCostNote) {
            this.studyForm.proposalSituation.ageGroupCostNote = this.studyForm.proposalSituation.ageGroupCostNote
                .replaceAll('&amp;35;', '#').replaceAll('&amp;42;', '*')
                .replaceAll('&35;', '#').replaceAll('&42;', '*');
          }
          if (this.studyForm.proposalSituation.financialComparisonNote) {
            this.studyForm.proposalSituation.financialComparisonNote = this.studyForm.proposalSituation.financialComparisonNote
                .replaceAll('&amp;35;', '#').replaceAll('&amp;42;', '*')
                .replaceAll('&35;', '#').replaceAll('&42;', '*');
          }

        } else {
          await this._quoteService.detail(this.$route.query.id)
            .then((response) => {
              if (response && response.data) {
                const quoteData = response.data;
                
                if (typeof quoteData.lead.id != 'undefined' && quoteData.lead.id != ''
                  && typeof quoteData.lead.cnpj != 'undefined' && quoteData.lead.cnpj != ''
                  && typeof quoteData.lead.commercialName != 'undefined' && quoteData.lead.commercialName != ''
                  && typeof quoteData.lead.contact.name != 'undefined' && quoteData.lead.contact.name != ''
                  && typeof quoteData.lead.contact.mobilePhone != 'undefined' && quoteData.lead.contact.mobilePhone != ''
                  && typeof quoteData.lead.contact.email != 'undefined' && quoteData.lead.contact.email != '') {

                    this.studyForm.quoteId = this.$route.query.id;
                    this.studyForm.state = quoteData.state;
                    this.studyForm.leadId = quoteData.lead.id;
                    this.studyForm.salesChannelId = quoteData.lead.salesChannelId;
                    this.studyForm.documentNumber = quoteData.lead.cnpj;
                    this.studyForm.legalName = quoteData.lead.comercialName;
                    this.studyForm.partnerName = quoteData.lead.comercialName;
                    this.studyForm.contactDocumentNumber = quoteData.lead.contact.cpf
                    this.studyForm.contactName = quoteData.lead.contact.name;
                    this.studyForm.contactPhone = quoteData.lead.contact.mobilePhone;
                    this.studyForm.contactEmail = quoteData.lead.contact.email;

                }else {
                  this.fisrtValidationAlert = true;
                  this.fisrtValidationError = 'Dados da oportunidade associada a solicitação de estudo incompletos. Verifique se CNPJ, Razão Social e Nome Fantasia, além dos dados de contato Nome, Telefone e E-mail.';
                }
              } else {
                this.fisrtValidationAlert = true;
                this.fisrtValidationError = 'Estudo não encontrado!.';
              }
            })
            .catch((error) => {
              this.fisrtValidationAlert = true;
              this.fisrtValidationError = 'Ocorreu um erro ao tentar consultar a solicitação de estudo.';
            });
          
        }
      } else {
        if (typeof this.$route.query.type != 'undefined') {

          //Valida os parametros.
          if (typeof this.$route.query.id != 'undefined' && this.$route.query.id != ''
              && typeof this.$route.query.cnpj != 'undefined' && this.$route.query.cnpj != ''
              && typeof this.$route.query.legal_name != 'undefined' && this.$route.query.legal_name != ''
              && typeof this.$route.query.partner_name != 'undefined' && this.$route.query.partner_name != ''
              //&& typeof  this.$route.query.cpf != 'undefined' && this.$route.query.cpf!=''
              && typeof this.$route.query.name != 'undefined' && this.$route.query.name != ''
              && typeof this.$route.query.phone != 'undefined' && this.$route.query.phone != ''
              && typeof this.$route.query.email != 'undefined' && this.$route.query.email != '') {

            //consulta o estudo por leadId
            let content = await this._studyService.findByLeadId(this.$route.query.id);
            if (content.data != '') {
              this.studyForm = content.data;
              this.studyForm.state = content.state;
              if (this.studyForm.proposalSituation.financialConsolidatedNote) {
                this.studyForm.proposalSituation.financialConsolidatedNote = this.studyForm.proposalSituation.financialConsolidatedNote
                    .replaceAll('&amp;35;', '#').replaceAll('&amp;42;', '*')
                    .replaceAll('&35;', '#').replaceAll('&42;', '*');
              }
              if (this.studyForm.proposalSituation.ageGroupCostNote) {
                this.studyForm.proposalSituation.ageGroupCostNote = this.studyForm.proposalSituation.ageGroupCostNote
                    .replaceAll('&amp;35;', '#').replaceAll('&amp;42;', '*')
                    .replaceAll('&35;', '#').replaceAll('&42;', '*');
              }
              if (this.studyForm.proposalSituation.financialComparisonNote) {
                this.studyForm.proposalSituation.financialComparisonNote = this.studyForm.proposalSituation.financialComparisonNote
                    .replaceAll('&amp;35;', '#').replaceAll('&amp;42;', '*')
                    .replaceAll('&35;', '#').replaceAll('&42;', '*');
              }
            } else {
              this.studyForm.leadId = this.$route.query.id;
              this.studyForm.salesChannelId = this.$route.query.sales_channel_id;
              this.studyForm.documentNumber = this.$route.query.cnpj;
              this.studyForm.legalName = this.$route.query.legal_name;
              this.studyForm.partnerName = this.$route.query.partner_name;
              this.studyForm.contactDocumentNumber = this.$route.query.cpf
              this.studyForm.contactName = this.$route.query.name;
              this.studyForm.contactPhone = this.$route.query.phone;
              this.studyForm.contactEmail = this.$route.query.email;
            }
          } else {
            this.fisrtValidationAlert = true;
            this.fisrtValidationError = 'Dados do lead incompletos. Verifique se CNPJ, Razão Social e Nome Fantasia, além dos dados de contato Nome, Telefone e E-mail.';
          }
        }

        if (this.studyForm.quoteId != null && this.studyForm.quoteId != '') {
          this.fisrtValidationAlert = true;
          this.fisrtValidationError = 'O estudo desta empresa deve ser acessado através da solicitação de estudo já enviada.';
        }
      }

      await this.getPermissions();
      if (this.studyForm.salesChannelId == '') {
        this.fisrtValidationAlert = true;
        this.fisrtValidationError = 'É necessário associar a Seguimentação do Canal ao Lead para prosseguir.';
      } else {
        this.getStudyConfigurations();
      }
    } else {
      this.fisrtValidationAlert = true;
      this.fisrtValidationError = 'Não autenticado!!!';
    }
    if (this.studyForm.studyConfiguration != null) {
      this.getStudyTypes();
    }
    if (this.studyForm.benefit && this.studyForm.benefit.id) {
      this.getQuoteReasons();
    }
  }
  ,
  name: 'study_model_proposal.vue',
}
;
</script>

<style scoped>
.padding-top-25 {
  padding-top: 25px;
}

.ro {
  position: absolute;
  z-index: 2;
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;

  background-color: color-mix(in srgb, var(--v-muted-base), transparent 23%);
  display: table;
  transition: opacity 0.3s ease;
}
</style>
